import ShipsListContent from './ShipsListContent'

export default ShipsListContent
